import { useStaticQuery, graphql } from "gatsby";

const useSiteMetadata = () => {
    const data = useStaticQuery(graphql`
        query SiteMetaQuery {
            site {
                siteMetadata {
                    siteUrl
                }
            }
            wp {
                seo {
                    schema {
                        companyLogo {
                            mediaItemUrl
                        }
                    }
                }
            }
        }
    `);

    const companyLogo = data.wp?.seo?.schema?.companyLogo?.mediaItemUrl ?? "";

    return {
        ...data.site.siteMetadata,
        companyLogo,
    };
};

export default useSiteMetadata;
